import { api } from './api';

export const popularStylesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPopularStyles: builder.query({
      query: () => '/admin/popular',
      transformResponse: (response) => response?.data ?? [],
      providesTags: ['PopularStyle'],
    }),
    getPopularStyle: builder.query({
      query: (id) => `/admin/popular/${id}`,
      transformResponse: (response) => response?.data,
      providesTags: (_, __, id) => [{ type: 'PopularStyle', id }],
    }),
    createPopularStyle: builder.mutation({
      query: (body) => ({
        url: '/admin/popular',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PopularStyle'],
    }),
    updatePopularStyle: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/popular/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['PopularStyle'],
    }),
    deletePopularStyle: builder.mutation({
      query: (id) => ({
        url: `/admin/popular/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PopularStyle'],
    }),
  }),
});

export const {
  useGetPopularStylesQuery,
  useGetPopularStyleQuery,
  useCreatePopularStyleMutation,
  useUpdatePopularStyleMutation,
  useDeletePopularStyleMutation,
} = popularStylesApi;
